import axios, { type AxiosInstance } from 'axios'

class Api {
  public instance: AxiosInstance

  constructor(axiosConfig: { baseURL: string }) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '',
    })
  }
}
export const apiClient = new Api({
  baseURL: import.meta.env.VITE_BACKEND_API,
})
